module.exports = __webpack_public_path__ + "img/step04_b_stand_basic_right_rear_leg.807f5f65.png";